import { ExternalLink, Music2 } from "lucide-react";
import { SITE } from "@/constants/testIds";

const YOUTUBE_ID = "pK5mtIvOips";
const YOUTUBE_URL = `https://youtu.be/${YOUTUBE_ID}`;

export const AudioPlayer = () => {
  return (
    <section
      id="listen"
      data-testid={SITE.audioPlayer}
      className="relative bg-background py-24 sm:py-32 bg-grain"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <p className="text-xs uppercase tracking-[0.3em] text-primary/90 mb-4 text-center">
          Featured Preview
        </p>
        <h2 className="font-serif text-4xl sm:text-5xl text-center text-foreground mb-3">
          A First Listen
        </h2>
        <div className="gold-rule w-20 mx-auto mb-12" />

        {/* YouTube embed framed elegantly */}
        <div className="relative border border-primary/25 bg-card/40 backdrop-blur-sm p-3 sm:p-4">
          <div className="absolute -inset-px pointer-events-none opacity-60" aria-hidden>
            <div className="absolute -left-12 top-1/2 -translate-y-1/2 w-40 h-40 rounded-full bg-primary/10 blur-3xl" />
            <div className="absolute -right-12 top-1/2 -translate-y-1/2 w-40 h-40 rounded-full bg-primary/10 blur-3xl" />
          </div>

          <div className="relative aspect-video w-full bg-black overflow-hidden">
            <iframe
              data-testid={SITE.audioPlayBtn}
              src={`https://www.youtube.com/embed/${YOUTUBE_ID}?rel=0&modestbranding=1`}
              title="Shabbat Shalom, America — Demo Preview"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
            />
          </div>

          <div className="relative flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-2 sm:px-4 pt-5 pb-2">
            <div>
              <div className="flex items-center gap-2 text-primary/80 mb-1.5">
                <Music2 className="w-3.5 h-3.5" strokeWidth={1.5} />
                <span className="text-[11px] uppercase tracking-[0.28em]">A First Listen</span>
              </div>
              <h3 className="font-serif text-xl sm:text-2xl text-foreground leading-tight">
                Shabbat Shalom, America
              </h3>
              <p className="text-sm text-foreground/55 mt-1">
                Words &amp; music by Polina Rachel Furman
              </p>
            </div>

            <a
              href={YOUTUBE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="audio-youtube-link"
              className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-primary/90 hover:text-primary transition-colors duration-300 self-start sm:self-auto"
            >
              Watch on YouTube
              <ExternalLink className="w-3.5 h-3.5" strokeWidth={1.5} />
            </a>
          </div>
        </div>

        {/* Demo Notice */}
        <div
          data-testid={SITE.demoNotice}
          className="mt-8 border-l-2 border-primary/60 pl-5 py-3 text-sm text-foreground/65 leading-relaxed max-w-3xl mx-auto font-serif italic"
        >
          What you&apos;re hearing is a first sketch — an AI-assisted recording made
          to share the heart of the song: its words, melody, and feeling.
          Lyrics and music are original to{" "}
          <span className="text-foreground/90 not-italic font-sans">Polina Rachel Furman</span>.
          A fully produced studio version is on its way.
        </div>
      </div>
    </section>
  );
};
